import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user saves a new title for a workspace agent thread via the inline rename form',
  name: 'agent_thread_renamed',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The new title saved by the user',
      name: 'name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
